(function ($, njm) {
    'use strict';

    njm.views.verticalTabsDesktop = Backbone.View.extend({

        events: {
            "click .tablist .tab": "tabClick",
			"keydown .tablist .tab": "tabKey"
        },

        // supported medias for this view
        medias: ['desktop', 'tablet'],
		
		tabFocus: 0,

        /**
         * Initialize
         */
        initialize: function () {
			this.template = this.$el.parents('.comp-vertical-tabs').find('[data-template="comp-vertical-tabs-desktop"]').html();

            // Render
            this.render();
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template);
        },
		
		tabClick: function(event) {
			var $target = $(event.target).closest('.tab'),
				contentID = $target.attr('data-content');
			
			this.$('.tablist button').removeClass('active').attr('aria-selected',false).attr('tabindex','-1');
			
			$target.addClass('active').attr('aria-selected',true).attr('tabindex','0');
			
			this.$('.content .content-item').hide().attr('hidden',true);
			
			$target.parents('.box').find('.content .content-item[data-content=' + contentID + ']').show().removeAttr('hidden');
			
			this.tabFocus = parseInt($target.data('content')) - 1;
		},
		
		tabKey: function(event) {
			var $target = $(event.target).closest('.tab'),
				key = event.which,
				tabs = this.$('.tab');
			
			if (key === 13) { //enter key
				$target.trigger('click');
			} 
			
			if (key === 38 || key === 40) { //up or down key
				event.preventDefault();
				tabs.attr('tabindex','-1');
				
				if (key === 38) { //up key
					//focus on the previous tab element
					this.tabFocus--;
					if (this.tabFocus < 0) {
						this.tabFocus = tabs.length - 1;
					}
				}
				
				if (key === 40) { //down key
					//focus on the next tab element
					this.tabFocus++;
					if (this.tabFocus >= tabs.length) {
						this.tabFocus = 0;
					}
				}
				
				$(tabs[this.tabFocus]).attr('tabindex','0').focus();
			} 
		}
    });
})(jQuery, njm);
